export const saveEditorSettingsInit = formData => {
    return {
        type: 'SAVE_EDITOR_SETTINGS_INIT',
        payload: formData
    }
}